import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import PSO from '../../../../services/PSO';
import Strings from '../../../../translations/Translations';

const IMAGE_SRC = process.env.REACT_APP_PZ_IMAGE_SRC;

export default function QuickApprove(props) {
  const { currentIt } = props;

  const { authenticated, toggleLoading } = useAuth();
  const [photos, setPhotos] = useState([]);
  const [currentPhoto, setCurrentPhoto] = useState();

  const getPhotos = useCallback(async () => {
    toggleLoading(true);

    try {
      const response = await PSO.getRemixNonApprovedElements({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid,
        enmax: 25,
        estatus: 6
      });

      if (response.result === 'success') {
        if (response.its_media) {
          setPhotos(response.its_media);
          if (response.its_media.length > 0) {
            setCurrentPhoto(response.its_media[0].eid);
          }
        }
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [currentIt, authenticated, toggleLoading, setPhotos, setCurrentPhoto]);

  const approveElement = useCallback(async (eid, etype) => {
    toggleLoading(true);

    try {
      const response = await PSO.approveElementInRemix({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid,
        eid,
        etype
      });

      if (response.result === 'success') {
        toast.success('Success');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      getPhotos();
      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, currentIt, toggleLoading, getPhotos]);

  const disapproveElement = useCallback(async (eid, etype) => {
    toggleLoading(true);

    try {
      const response = await PSO.disapproveElementInRemix({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid,
        eid,
        etype
      });

      if (response.result === 'success') {
        toast.success('Success');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      getPhotos();
      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, currentIt, toggleLoading, getPhotos]);

  useEffect(() => {
    getPhotos();
  }, [getPhotos]);

  return (
    <Fragment>
      <Row>
        <Col>
          <div className="mt-2 alert alert-secondary fade show" role="alert">
            {Strings('quick_approve_explain')}
          </div>
        </Col>
      </Row>

      {photos && photos.length === 0 && (
        <Row>
          <Col>
            <div className="mt-2 alert alert-success fade show" role="alert">
              {Strings('no_photos')}
            </div>
          </Col>
        </Row>
      )}

      {photos && photos.map((value, index) => (
        <Row key={value.eid} style={{ display: (currentPhoto === value.eid) ? '' : 'none' }}>
          <Col md={2} className="align-self-center">
            <Button
              color="light"
              disabled={index === 0}
              onClick={() => {
                if (index !== 0) {
                  const previousPhoto = photos[index - 1].eid;
                  setCurrentPhoto(previousPhoto);
                }
              }}
            >
              {Strings('previous')}
            </Button>
          </Col>
          <Col md={8} className="text-center">
            <img
              className="img-fluid"
              alt=""
              src={IMAGE_SRC.replace('{id}', value.eid)}
            />

            <div className="mt-3">
              <Button
                color="success"
                className="m-1"
                onClick={() => approveElement(value.eid, value.etype)}
              >
                {Strings('approve')}
              </Button>
              <Button
                color="danger"
                className="m-1"
                onClick={() => disapproveElement(value.eid, value.etype)}
              >
                {Strings('disapprove')}
              </Button>
            </div>
          </Col>
          <Col md={2} className="align-self-center">
            <Button
              color="light"
              disabled={index === (photos.length - 1)}
              onClick={() => {
                if (index !== (photos.length - 1)) {
                  const nextPhoto = photos[index + 1].eid;
                  setCurrentPhoto(nextPhoto);
                }
              }}
            >
              {Strings('next')}
            </Button>

          </Col>
        </Row>
      ))}
    </Fragment>
  );
}
